<template>
  <div class="overlay" v-if="loading" :style="style">
    <pulse-loader class="spinner" :size="size" :color="color"/>
  </div>
</template>

<script>
  export default {
    name: 'OverlaySpinner',
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      color: {
        type: String,
        default: '#2980b9'
      },
      size: {
        type: String,
        default: '15px'
      },
      opacity: {
        type: Number,
        default: 0.5
      }
    },
    computed: {
      style() {
        return {
          opacity: this.opacity,
          filter: `alpha(opacity=${this.opacity})`,
        };
      },
    }
  };
</script>

<style lang="scss" scoped>
  .overlay {
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }

  .spinner {
    margin: auto;
  }
</style>
